/**
 * @generated SignedSource<<5f85634e3fb7e4c5b3384979b54f24b4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespCreatorsComponents_viewer$data = {
  readonly creatorRootPage: {
    readonly " $fragmentSpreads": FragmentRefs<"SbRespRecentSales_creatorRootPage" | "SbSharedCategoryTabs_creatorRootPage" | "SbSharedCreatorTopContent_creatorRootPage" | "SbSharedRelatedCreatorBuyPages_creatorRootPage">;
  } | null;
  readonly isRelatedBuyPagesEnabled: boolean | null;
  readonly isRelatedCreatorsModuleEnabled: boolean | null;
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCategoryTabs_viewer" | "SbSharedCreatorTopContent_viewer" | "SbSharedTopTileController_viewer" | "SharedRelatedPages_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "SbRespCreatorsComponents_viewer";
};
export type SbRespCreatorsComponents_viewer$key = {
  readonly " $data"?: SbRespCreatorsComponents_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "uriRef"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCreatorsComponents_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "alias": "isRelatedCreatorsModuleEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "relatedCreatorsModule"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"relatedCreatorsModule\")"
    },
    {
      "alias": "isRelatedBuyPagesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "RELATED_BUY_PAGES"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"RELATED_BUY_PAGES\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCategoryTabs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedPages_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTopTileController_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCreatorTopContent_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "CreatorRootPage",
      "kind": "LinkedField",
      "name": "creatorRootPage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedCreatorTopContent_creatorRootPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedCategoryTabs_creatorRootPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRelatedCreatorBuyPages_creatorRootPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespRecentSales_creatorRootPage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c0d8095f1e3b80744af2c62c0d23e37e";

export default node;
